import AxiosInstance from '../../config/AxiosInstance';

export interface CustomerCompany {
    id: string;
    companyName: string;
    status: string | null;
}

// InnovX staff only; the API caps limit at 50 and never lists platform-owner or deleted companies.
const searchCustomerCompanies = async (params: { search: string; page: number; limit: number }) => {
    const { data } = await AxiosInstance.get('/api/platform/companies', { params });
    return { data };
};

// The current company's record; a support session may read only the company it is in.
const getCompanyDetail = async (companyId: string) => {
    const { data } = await AxiosInstance.get(`/api/companies/${encodeURIComponent(companyId)}`);
    return { data };
};

export {
    searchCustomerCompanies,
    getCompanyDetail
}
